import * as Yup from "yup";
import getForm from "./form";
import { MAX_COUNTRIES_EXPORT } from "./limits";

const {
  formField: { countryExport },
} = getForm();

const validations = Yup.object().shape({
  [countryExport.name]: Yup.array()
    .of(Yup.number())
    .min(1, countryExport.errorMsg)
    .max(MAX_COUNTRIES_EXPORT, countryExport.errorMinMaxMsg)
    .required(countryExport.errorMsg),
});

export default validations;
